export default __webpack_public_path__ + "static/media/C5.069e46b8.jpg";